import { render, staticRenderFns } from "./SleepSidebar.vue?vue&type=template&id=0f03987e&"
import script from "./SleepSidebar.vue?vue&type=script&lang=js&"
export * from "./SleepSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f03987e')) {
      api.createRecord('0f03987e', component.options)
    } else {
      api.reload('0f03987e', component.options)
    }
    module.hot.accept("./SleepSidebar.vue?vue&type=template&id=0f03987e&", function () {
      api.rerender('0f03987e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/sleep/SleepSidebar.vue"
export default component.exports